import { BaseAnalyticsProvider } from './BaseAnalyticsProvider';

export class AnalyticsV2Provider extends BaseAnalyticsProvider {}
